import FullStory from 'clients/fullstory'
import { initializeEnv } from 'environment'

initializeEnv(window.LZ.ENV)
FullStory.initialize()
